export enum Ayudas {
	// Principales
	BandejaPrestador = 'mis-establecimientos',
	Notificaciones = 'notificacion',
	DetalleSolicitud = 'detalle-solicitud',
	Arrendatario = 'arrendatario',
	// Pasos
	CompletaInformacionEstablecimineto = 'completa-informacion',
	CompletaInformacionInmueble = 'completa-informacion-inmueble',
  CompletaInformacionPlataformas = 'completa-informacion-plataformas',
	CompletaInformacionGuia = 'completa-informacion-guia',
	Capacidad = 'capacidad',
	TipoEstablecimiento = 'tipo-establecimiento',
	CodigoConducta = 'codigo-conducta',
	PagoParafiscal = 'pago-parafiscal',
	Encuesta = 'encuesta',
	Fontur = 'fontur',
	OtrasSolicitudes = 'otra-solicitudes'
}
